module.exports = __webpack_public_path__ + "2023-eb1ab710.webp";